import { PhoneCallInterface } from '@/interfaces/PhoneCall.interface';
import BaseApiClient from '../BaseApiClient';
import ApiClient from '../ApiClient';
import { AxiosResponse } from 'axios';

export class ApiPhoneCall extends BaseApiClient {
  private api!: ApiClient;

  setApiClient(api: ApiClient) {
    this.api = api;
  }
  /**
   * Gets all items
   */
  async get(id: number): Promise<PhoneCallInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/phone-calls/${id}`)
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
  async downloadSummaryOrTranscript(
    id: number | string,
    tab: string
  ): Promise<AxiosResponse<Blob>> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/phone-calls/${id}/${tab}`, {
          responseType: 'blob'
        })
        .then((res) => {
          if (res.data) {
            resolve(res);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { phoneCallQueryKeys } from './query-keys';
export {
  usePhoneCallDownloadSummaryOrTranscriptQuery,
  usePhoneCallQuery
} from './use-phone-call-queries';
export type { PhoneCallDownloadQueryParams } from './use-phone-call-queries';
